import FunnelPage from "components/funnels/FunnelPage";
import FunnelsList from "components/funnels/FunnelsList";
import Header from "components/Header";
import PageTransition from "components/PageTransition";
import ProgressBar from "components/ProgressBar";
import LoginPage from "components/auth/LoginPage";
import SignUpPage from "components/auth/SignUpPage";
import Dashboard from "components/dashboard";
import Subscriptions from "components/subscriptions";
import Billing from "components/billing";
import { useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";

function App() {
  return (
    <Router>
      <MainContent />
    </Router>
  );
}

const MainContent = () => {
  const location = useLocation();
  const isFunnelPage = location.pathname.startsWith("/funnels/");
  const isLoginPage = location.pathname === "/login";
  const isSignUpPage = location.pathname === "/signup";
  const isRootPage = location.pathname === "/";
  const [progress, setProgress] = useState(0);
  const [showProgressBar, setShowProgressBar] = useState(false);

  // Determine the padding class based on the route
  const paddingClass = isFunnelPage || isRootPage ? "px-6" : "px-1";
  const widthClass =
    isFunnelPage || isRootPage ? "w-full md:w-1/2" : "w-full md:w-2/3";

  return isLoginPage || isSignUpPage ? (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/signup" element={<SignUpPage />} />
      <Route path="/dashboard" element={<Dashboard />} />
    </Routes>
  ) : (
    <div className={paddingClass}>
      <Header
        showProgressBar={isFunnelPage}
        progressBar={isFunnelPage && <ProgressBar progress={progress} />}
      />
      {/* Center the content and set its width to w-1/2 */}
      <div className="flex justify-center">
        <div className={`relative mt-4 ${widthClass}`}>
          <PageTransition locationKey={location.pathname}>
            <Routes location={location}>
              <Route path="/" element={<FunnelsList />} />
              <Route
                path="/funnels/:funnelId/*"
                element={
                  <FunnelPage
                    setProgress={setProgress}
                    setShowProgressBar={setShowProgressBar}
                  />
                }
              />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/subscriptions" element={<Subscriptions />} />
              <Route path="/billing" element={<Billing />} />
            </Routes>
          </PageTransition>
        </div>
      </div>
    </div>
  );
};

export default App;
